import { BetaFeature } from "@tvg/sh-lib-beta-program/types";
import {
  AlertMessages,
  ModalContent,
  PAGE_ACTION
} from "@tvg/sh-lib-beta-program/types/redux";
import { betaFeatureMock } from "../containers/BetaFeaturesModal/__mocks__/betaFeatures";

export const betaProgramModal = {
  isOpen: false
};

export const programPage: ModalContent = {
  title: "New Program Page",
  imageUrl: "",
  description: {
    actions: [
      {
        type: PAGE_ACTION.LEARN_MORE,
        text: "Learn More",
        variant: "secondary"
      },
      {
        type: PAGE_ACTION.CONFIRM,
        text: "Try the new Beta",
        variant: "primary"
      }
    ],
    content: betaFeatureMock.description
  },
  details: {
    actions: [
      {
        type: PAGE_ACTION.LATER,
        text: "Maybe Later",
        variant: "secondary"
      },
      {
        type: PAGE_ACTION.CONFIRM,
        text: "Try the new Beta",
        variant: "primary"
      }
    ],
    // @ts-ignore
    content: betaFeatureMock.details[0]
  },
  welcomeMessage: {
    actions: [
      {
        type: PAGE_ACTION.START,
        text: "Let's Start",
        variant: "primary"
      }
    ],
    content: {
      text: betaFeatureMock.description,
      title: "Some title"
    }
  }
};

export const alertMessages: AlertMessages = {
  exit: {
    title: "Exit New Program Page",
    description: "Are you sure you want leave our beta program?"
  },
  dismiss: {
    description:
      "Don’t worry. Beta Features can still be enabled in your Account options 78123479"
  }
};

export const myStable: ModalContent = {
  title: "My Stable",
  description: { content: betaFeatureMock.description, actions: [] }
};

export const features: Record<BetaFeature, ModalContent> = {
  programPage,
  myStable
};
